'use client';

import { c as _c } from "react/compiler-runtime";
import { ClientUserType, updateClientLogContext } from '@spa/lib/logging/clientLogContext';
import { ReactElement, useEffect } from 'react';
import { RootState } from '@spa/lib/store/RootState';
import useFullPath from '@spa/lib/react/hooks/useFullPath';
import { useSelector } from 'react-redux';

// Feeds the browser logger's client-side context (route/sessionGuid/userType/buildId — no IP,
// see clientLogContext.ts) from redux + the current route. Mount once near the app root.
const ClientLogContextSyncComponent = () => {
  const $ = _c(6);
  const {
    pathname
  } = useFullPath();
  const sessionGuid = useSelector(_temp);
  const isAuthenticated = useSelector(_temp2);
  const buildId = useSelector(_temp3);
  const userType = isAuthenticated ? "authenticated" : "anonymous";
  let t0;
  let t1;
  if ($[0] !== buildId || $[1] !== pathname || $[2] !== sessionGuid || $[3] !== userType) {
    t0 = () => {
      updateClientLogContext({
        route: pathname,
        sessionGuid,
        userType,
        buildId
      });
    };
    t1 = [pathname, sessionGuid, userType, buildId];
    $[0] = buildId;
    $[1] = pathname;
    $[2] = sessionGuid;
    $[3] = userType;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  return null;
};
export default ClientLogContextSyncComponent;
function _temp(state) {
  return state.session.content?.guid ?? null;
}
function _temp2(state_0) {
  return state_0.auth.authenticatedUserId !== null;
}
function _temp3(state_1) {
  return state_1.settings.settings?.buildId ?? null;
}